/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelRmSpcities.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/rm-spcities";

export class AutogenModelRmSpcities<RowType extends ModelRow> extends Endpoint<RowType, RowRmSpcitiesFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowRmSpcities extends ModelRow<RowRmSpcitiesFields> {
	constructor(values?: Partial<RowRmSpcitiesFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowRmSpcitiesFields {
	company_id: string;
	county: string;
	id: number;
	latitude: number;
	longitude: number;
	name: string;
	state_id: string;
	zip_code: string;
	state_id: string;
}

